var map = {
	"./add.svg": "5110",
	"./circle-solid-info.svg": "dad3",
	"./delete.svg": "a3dd",
	"./medal.svg": "2875",
	"./search.svg": "679a",
	"./swiper-button.svg": "630f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";